import { useInfiniteQuery } from '@tanstack/react-query'

import { ApiPagedPayload } from '@/api/shared/types'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { NewsService } from '..'
import { FeedListPayload } from '../lib/news.types'

const FEED_LIST_QUERY_KEY = 'feed-list'

export const useFeedList = ({
  pageSize = 20,
  isShownOnMain
}: ApiPagedPayload<Omit<FeedListPayload, 'projectId'>>) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  return useInfiniteQuery({
    queryKey: [FEED_LIST_QUERY_KEY, projectId],
    queryFn: async ({ pageParam }) => {
      const {
        data: { data, page, total }
      } = await NewsService.getFeedList({
        projectId,
        pageSize,
        page: pageParam,
        isShownOnMain
      })

      return {
        response: data,
        page: total - page * pageSize > 0 ? pageParam : undefined
      }
    },
    enabled: Boolean(projectId),
    staleTime: 0,
    select: response => response.pages.map(page => page.response),
    initialPageParam: 1,
    getPreviousPageParam: lastPage =>
      lastPage.page === 0 ? lastPage.page - 1 : undefined,
    getNextPageParam: firstPage =>
      firstPage.page ? firstPage.page + 1 : undefined
  })
}
